import { type ColumnDefGeneric } from '@strata/react-grid';
import { ClaimStatusIcon } from '@strata/react-status-icons';

import { type ClaimSummary } from 'store/api/medbillingApi';

export const ClaimStatusRowHeader = () => (
    <div className="sds_claim-status-row__header">
        <div>999 Status</div>
        <div>277 CA Status</div>
        <div>Claim Status</div>
    </div>
);

/* eslint-disable react/prop-types */
export const ClaimStatusRow: ColumnDefGeneric<ClaimSummary, 'internal_claim_status'>['cell'] = ({
    getValue,
    row,
}) => (
    <div className="sds_claim-status-row">
        <div className="sds_claim-status-row__icon-container">
            <ClaimStatusIcon status={row.original.status_999} />
            <div className="sds_claim-status-row__line" />
        </div>
        <div className="sds_claim-status-row__icon-container">
            <ClaimStatusIcon status={row.original.status_277_ca} />
            <div className="sds_claim-status-row__line" />
        </div>
        <div className="sds_claim-status-row__icon-container">
            <ClaimStatusIcon status={getValue()} />
        </div>
    </div>
);
/* eslint-enable react/prop-types */
